module.exports = __webpack_public_path__ + "static/media/surface-icon.2ebf6b01.svg";